import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, throwError, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from '../../../environment';
import { MilkDeliveryMonthSummary, MilkDeliverySummary } from '../models/milk-delivery.model';

@Injectable({
  providedIn: 'root',
})
export class MilkDeliveryService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/dairy-factory/secure/';

  public get(startDate: string, endDate: string): Observable<MilkDeliverySummary[]> {
    return this.http
      .get<
        MilkDeliverySummary[]
      >(`${this.baseUrl}milk-deliveries?start=${startDate}&end=${endDate}`)
      .pipe(
        map((response) => response),
        catchError((error: HttpErrorResponse): Observable<MilkDeliverySummary[]> => {
          if (error.status === 404) {
            return of([]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  public getMonthSummary(startDate: string, endDate: string): Observable<MilkDeliveryMonthSummary> {
    return this.http
      .get<MilkDeliveryMonthSummary>(
        `${this.baseUrl}report/milk-deliveries?start=${startDate}&end=${endDate}`,
      )
      .pipe(map((response) => response));
  }
}
